import React, { createContext, useContext, useState, useEffect } from 'react';
import Api from '../_helpers/Api';
import { useAuthDataContext } from './Auth';

/**
 * NewReservationsProvider
 * 
 * Uses the existing endpoint:
 * GET /api/reservations/not-reviewed
 * 
 * Expected Response:
 * {
 *   "total": 2,
 *   "data": [...]
 * }
 * 
 * The provider extracts the "total" field to display the badge count.
 */

const NewReservationsContext = createContext();

export const useNewReservationsContext = () => {
    return useContext(NewReservationsContext);
};

export function NewReservationsProvider({ children }) {
    const auth = useAuthDataContext();
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(true);

    const loadCount = () => {
        if (!auth || auth.isAdmin()) {
            setCount(0);
            setLoading(false);
            return;
        }

        // Use the existing endpoint that returns the full data
        Api.get('reservations/not-reviewed')
            .then(res => {
                // Extract count from the total field
                const total = res.data.total || 0;
                console.log('Loaded reservations count:', total);
                setCount(total);
                setLoading(false);
            })
            .catch(err => {
                console.error('Failed to load new reservations count:', err);
                setLoading(false);
                setCount(0);
            });
    };

    useEffect(() => {
        loadCount();
        
        // Refresh count every 2 minutes
        const interval = setInterval(loadCount, 120000);
        
        return () => clearInterval(interval);
    }, [auth]);

    const refresh = () => {
        loadCount();
    };

    return (
        <NewReservationsContext.Provider value={{ count, loading, refresh }}>
            {children}
        </NewReservationsContext.Provider>
    );
}
